import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
let inflight = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f(cache));

export const loadOptions = (force = false) => {
  if (cache && !force) return Promise.resolve(cache);
  inflight = inflight && !force ? inflight : api.get("/options").then((r) => { cache = r.data; inflight = null; emit(); return cache; }).catch(() => { inflight = null; return cache || {}; });
  return inflight;
};

export const saveOptions = async (name, items) => {
  const { data } = await api.put(`/options/${name}`, { items });
  cache = { ...(cache || {}), [name]: data.items };
  emit();
  return data.items;
};

export function useSiteOptions() {
  const [opts, setOpts] = useState(cache || {});
  useEffect(() => { subs.add(setOpts); loadOptions(); return () => subs.delete(setOpts); }, []);
  return opts;
}

export const mergeOptions = (builtins, saved = [], { all = false } = {}) => {
  const byKey = Object.fromEntries(saved.map((s) => [s.key, s]));
  const base = builtins.map((b) => ({ ...b, custom: false, hidden: !!byKey[b.key]?.hidden }));
  const extra = saved.filter((s) => s.custom && !builtins.some((b) => b.key === s.key));
  const list = [...base, ...extra];
  return all ? list : list.filter((x) => !x.hidden);
};
